module.exports = __webpack_public_path__ + "static/wang-profile-78ca2e7e812954df1566b5a72ae44d66.jpg";